import { render, staticRenderFns } from "./ResDirectory.vue?vue&type=template&id=4781e734&scoped=true"
import script from "./ResDirectory.vue?vue&type=script&lang=js"
export * from "./ResDirectory.vue?vue&type=script&lang=js"
import style0 from "./ResDirectory.vue?vue&type=style&index=0&id=4781e734&prod&lang=scss&scoped=true"
import style1 from "./ResDirectory.vue?vue&type=style&index=1&id=4781e734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781e734",
  null
  
)

export default component.exports